export default __webpack_public_path__ + "8489eff6759ee5bad24dff4c8d29d1fa.svg";